/**
 * Shared helper to convert offer workflow results into a single dialog state.
 * Keeps dialog routing DRY across SummaryCaseTable + EvidenceComparisonTable.
 */

export const OFFER_FLOW_DIALOG_TYPES = {
  SUBSET_WARNING: 'subset_warning',
  MISSING_OFFERS: 'missing_offers',
  MISSING_COMPS: 'missing_comps',
  SEND_SELECTED_CONFIRM: 'send_selected_confirm',
  WORKUPS_ABOVE_IFMV: 'workups_above_ifmv',
};

export const getOfferFlowDialogFromResult = ({ result, selectedRows }) => {
  if (!result || result.success) return null;

  if (result.validationType === 'subset_warning') {
    return {
      dialog: {
        type: OFFER_FLOW_DIALOG_TYPES.SUBSET_WARNING,
        openCases: result.openCasesNotSelected || result.openCases || [],
        selectedRows: selectedRows || [],
      },
      context: {
        openCases: result.openCasesNotSelected || result.openCases || [],
      },
    };
  }

  if (result.validationType === 'missing_offers') {
    return {
      dialog: {
        type: OFFER_FLOW_DIALOG_TYPES.MISSING_OFFERS,
        missingOffersList: (result.missingOffers || []).map((o) => o.Address),
        selectedRows: selectedRows || [],
      },
      context: {
        missingOffers: result.missingOffers || [],
      },
    };
  }

  if (result.validationType === 'missing_comps') {
    return {
      dialog: {
        type: OFFER_FLOW_DIALOG_TYPES.MISSING_COMPS,
        missingCompsList: (result.missingCompsCases || []).map((c) => c.Address || c.parcel_id || c.id),
        selectedRows: selectedRows || [],
      },
      context: {
        missingCompsCases: result.missingCompsCases || [],
      },
    };
  }

  if (result.validationType === 'workups_above_ifmv') {
    return {
      dialog: {
        type: OFFER_FLOW_DIALOG_TYPES.WORKUPS_ABOVE_IFMV,
        workupsAboveIfmv: result.workupsAboveIfmv || [],
        selectedRows: selectedRows || [],
      },
      context: {
        workupsAboveIfmv: result.workupsAboveIfmv || [],
      },
    };
  }

  return null;
};

